import React, { useEffect, useState, useRef } from 'react';
import CardDashboardGeladeira from '../../../Componentes/CardDashboardGeladeira';
import CorpoPagina from '../../../Componentes/CorpoPagina';
import Espaçador from '../../../Componentes/Espaçador';
import SelectInput from '../../../Componentes/SelectInput';
import TopicoTexto from '../../../Componentes/TopicoTexto';
import '../../../Estilos/Dashboard.css';
import { useMediaQuery } from 'react-responsive';
import { apiService } from '../../../Services/ApiService';
import { useNavigate } from 'react-router-dom';
import DashboardTabs from './DashboardTabs';

export default function Dashboard() {
  const navigate = useNavigate();
  const componentRef = useRef();
  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });
  const { get } = apiService();
  const [environments, setEnvironments] = useState([]);
  const [dashboard, setDashboard] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [initialSelectionDone, setInitialSelectionDone] = useState(false);
  const isMobile = useMediaQuery({ query: `(max-width: 920px)` });
  const [selectedEnvironment, setSelectedEnvironment] = useState(null);
  const [hasSelectedTime, setHasSelectedTime] = useState(false);
  const [selectedDaysLabel, setSelectedDaysLabel] = useState('Selecione');
  const [atualizacao, setAtualizacao] = useState(0);
  const [hasSelectedEnvironment, setHasSelectedEnvironment] = useState(false);
  const [selectedEnvironmentLabel, setSelectedEnvironmentLabel] = useState('Todos');
  const [timeoutId, setTimeoutId] = useState(null);
  const rangerDays = [
    { value: 180000, label: 'A cada 3 minutos' },
    { value: 600000, label: 'A cada 10 minutos' },
    { value: 900000, label: 'A cada 15 minutos' },
    { value: 1800000, label: 'A cada 30 minutos' },
  ];
  const startAutoUpdate = (interval) => {
    const id = setInterval(() => {
      getDashboard();
    }, interval);
    setTimeoutId(id);
  };
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  useEffect(() => {
    if (selectedEnvironment) {
      startAutoUpdate(atualizacao);
    }
    return () => {
      clearInterval(timeoutId);
    };
  }, [selectedEnvironment]);

  useEffect(() => {
    if (selectedEnvironment) {
      getDashboard();
    }
  }, [selectedEnvironment]);

  useEffect(() => {
    getDashboard();
  }, []);

  //* setTime
  const handleSelecionar = (item) => {
    setSelectedDaysLabel(item.label);
    setAtualizacao(item.value);
    setHasSelectedTime(true);
    if (timeoutId) {
      clearInterval(timeoutId);
    }
    startAutoUpdate(item.value);
  };

  //* select first RangerDys
  useEffect(() => {
    if (rangerDays.length > 0 && !initialSelectionDone) {
      const firstRange = rangerDays[0];
      handleSelecionar(firstRange);
      setInitialSelectionDone(true);
    }
  }, [rangerDays, initialSelectionDone]);

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearInterval(timeoutId);
      }
    };
  }, [timeoutId]);

  const getDashboard = async () => {
    setIsLoading(true);

    try {
      if (selectedEnvironment && selectedEnvironment.value !== '') {
        //*all condition
        const { value: environmentId } = selectedEnvironment;
        const endpoint = `dashboard/refrigerator?environmentId=${environmentId}`;
        const response = await get(endpoint);

        if (response) {
          setDashboard(response);
        } else {
          setModalError({ visible: true, message: 'Resposta inválida da API' });
        }
      } else {
        const endpoint = `dashboard/refrigerator`;
        const response = await get(endpoint);

        if (response) {
          setDashboard(response);
        } else {
          setModalError({ visible: true, message: 'Resposta inválida da API' });
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setModalError({ visible: true, message: 'Erro ao buscar dados do ambiente' });
    } finally {
      setIsLoading(false);
    }
  };

  function defineStatus(tempMinimo, tempMaximo, atual) {
    if (atual < tempMinimo || atual > tempMaximo) {
      return 'NG';
    } else if (atual > tempMinimo + 1 && atual < tempMaximo - 1) {
      return 'OK';
    } else {
      return 'WARN';
    }
  }

  //* click select environment
  const handleEnvironmentSelect = (env) => {
    setSelectedEnvironmentLabel(env.label);
    setSelectedEnvironment(env);
    setHasSelectedEnvironment(true);
  };

  useEffect(() => {
    getEnvironments();
  }, []);

  const getEnvironments = async () => {
    setIsLoading(true);
    try {
      const data = await get('environments/all');

      if (data) {
        const environmentsList = data || [];
        //*all condition
        const allEnvironments = [
          { value: '', label: 'Todos' },
          ...environmentsList.map((env) => ({ value: env.id, label: env.name })),
        ];
        setEnvironments(allEnvironments);
      }
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar ambientes' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleNavigate = (id) => {
    navigate(`/Geladeira/${id}`);
  };

  return (
    <CorpoPagina loading={isLoading}>
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}
      <div className="ContainerGeral" ref={componentRef} style={{ minHeight: '100vh' }}>
        <DashboardTabs />
        <TopicoTexto titulo="Dashboard: Geladeiras" largura="80%" />

        <div className="CamposDashboard" style={{ width: isMobile ? '100%' : '98%' }}>
          <div className="CamposDashboard Esquerda" style={{ width: isMobile ? '100%' : '75%' }}>
            <SelectInput
              top={-28}
              bottom={12}
              padrao={{ value: '', label: selectedEnvironmentLabel }}
              titulo="Ambiente"
              largura={isMobile ? '100%' : '254px'}
              itens={environments}
              clicado={handleEnvironmentSelect}
            />
            <Espaçador espaço={16} />
            <SelectInput
              top={hasSelectedTime ? -28 : 0}
              bottom={12}
              padrao={{ value: '', label: selectedDaysLabel }}
              titulo="Alternar Tempo"
              largura={isMobile ? '100%' : '254px'}
              itens={rangerDays}
              clicado={handleSelecionar}
              erro={!hasSelectedTime}
              erroTexto="Selecione o tempo"
            />
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', width: '80vw' }}>
          <div className="CardsGeladeiraView">
            {dashboard.length === 0 ? (
              <div style={{ textAlign: 'center', width: '100%', marginTop: '20%' }}>
                <p>
                  <strong>Não existe dados para esse filtro.</strong>
                </p>
              </div>
            ) : (
              dashboard.map((item) => (
                <CardDashboardGeladeira
                  key={item.id}
                  environmentId={item.environment.id}
                  height={250}
                  maxW={600}
                  top={16}
                  width={'32%'}
                  valor={
                    item.temperature ? parseFloat(item.temperature).toFixed(2) : item.temperature
                  }
                  ok={defineStatus(
                    item.sensor.minTemperature,
                    item.sensor.maxTemperature,
                    item.temperature ? item.temperature : 0,
                  )}
                  id={item.macAddress}
                  nome={item.sensor.name}
                  porta={!item.endOfCourse}
                  data={formatDate(item.timestamp)}
                  eletricidade={item.energy}
                  minimo={item.sensor.minTemperature}
                  maximo={item.sensor.maxTemperature}
                  clicado={() => handleNavigate(item.environment.id)}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </CorpoPagina>
  );
}
